<ng-template #template>
    <div *ngIf="!!model" [class]="model.cssClasses.questionWrapper" [style]="rootStyle" (focusin)="model.focusIn()" #container>
        <ng-template [component]="{ name: componentName, data: componentData }"></ng-template>
    </div>
</ng-template>